import { z } from 'zod';
import { modelSchema } from '@/entities/base';

const basePlannedGoalSchema = z.object({
  planId: z.guid(),
  goalId: z.guid(),
  sortKey: z.string().min(1),
});

export const plannedGoalSchema = basePlannedGoalSchema.extend(modelSchema.shape);

export const plannedGoalCreateSchema = basePlannedGoalSchema.extend({
  id: z.guid(),
});
